import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { IconInfo } from '@wds/icons';
import DocuSignBadge from './DocuSignBadge';
import docusignLogo from './docusign-logo.svg';

const DocuSignConnectCard = ({ isConnected, accountLabel, connectUrl, onConnectClick }) => (
	<Box
		className='docusign-connection-panel'
		border='default'
		borderRadius='md'
		p={3}
	>
		<Box display='flex' alignItems='center' mb={2} gap={2}>
			{/* <img src={docusignLogo} alt='DocuSign' className='docusign-logo' height={20} /> */}
			<strong>Docusign</strong>
			{isConnected
				? <DocuSignBadge variant='connected' />
				: <DocuSignBadge variant='not_connected' />}
		</Box>

		{isConnected ? (
			<>
				<p className='text-muted small mb-0'>
					{gettext('Your DocuSign account is connected. Form fillers can sign when they reach this question.')}
				</p>
				<p className='text-muted small mt-2 mb-0'>
					{gettext("Note: Admins can't edit this form once Docusign is added")}
				</p>
					{accountLabel && (
					<>
						<p className='text-muted small mb-0 docusign-connect-account'>
							{accountLabel}
						</p>
					</>
				)}
				<p className='text-muted small mb-0 '>
						{gettext("Media you upload won't show in Docusign. If your form is over 50 MB, some text may not appear in full there." )}
				</p>
				
			</>
		) : (
			<>
				{/* <p className='text-muted small mb-3'>
					{gettext('Effortlessly collect signatures on forms')}
				</p>
				<p className='text-muted small mt-2 mb-0'>
					{gettext('Note: Form fillers will be redirected to DocuSign to sign when they reach this question.')}
				</p> */}
			</>
		)}
	</Box>
);

DocuSignConnectCard.propTypes = {
	isConnected: PropTypes.bool.isRequired,
	accountLabel: PropTypes.string,
	connectUrl: PropTypes.string,
	onConnectClick: PropTypes.func,
};

DocuSignConnectCard.defaultProps = {
	accountLabel: '',
	connectUrl: '',
	onConnectClick: null,
};

export default DocuSignConnectCard;
